import { connect } from 'react-redux'

import {
  fetchInitialData,
} from '../actions'

import TeamsoncallComponent from '../components/TeamsoncallComponent'

const mapStateToProps = (state) => {
  return {
    oncall: state.oncall,
  }
}

const mapDispatchToProps = (dispatch) => ({
  fetchData: () => dispatch(fetchInitialData()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamsoncallComponent)
